import { MenuItem, Select, Stack } from "@mui/material"
import { If } from "lib/@components/switch"
import { generate } from "library/guid/index.mjs"
import { RuleConditionRow } from "./rule-condition-row"

export function ConditionWithLabel({ item, index, conditions, combinator = "and", onUpdate, onCombinatorChange }) {
    const canRemove = conditions.length > 1
    const isLast = index === conditions.length - 1
    return (
        <Stack spacing={0.5}>
            <If value={index > 0}>
                <Select
                    data-cy="rule-combinator"
                    size="small"
                    value={combinator}
                    onChange={handleCombinatorChange}
                    sx={{
                        alignSelf: "flex-start",
                        minWidth: 80,
                        fontWeight: 700,
                        fontSize: 16,
                        "& .MuiSelect-select": { py: 0.5, px: 1.25 },
                    }}
                >
                    <MenuItem value="and">And</MenuItem>
                    <MenuItem value="or">Or</MenuItem>
                </Select>
            </If>
            <RuleConditionRow
                condition={item}
                onChange={handleChange}
                onRemove={handleRemove}
                onAdd={handleAdd}
                isLast={isLast}
                canRemove={canRemove}
            />
        </Stack>
    )

    function handleChange(updated) {
        const next = [...conditions]
        next[index] = updated
        onUpdate(next)
    }

    function handleRemove() {
        onUpdate(conditions.filter((_, i) => i !== index))
    }

    function handleAdd() {
        onUpdate([...conditions, { _id: generate(), field: "", operator: "", value: null }])
    }

    function handleCombinatorChange(e) {
        if (!onCombinatorChange) return
        onCombinatorChange(e.target.value === "or" ? "or" : "and")
    }
}
